export namespace QuoteFlowAction {
	export class Reset {
		static readonly type = '[QuoteFlow] Reset'
	}

	export class ResetAllowedPaths {
		static readonly type = '[QuoteFlow] Reset Allowed Paths'
	}

	export class AllowRetrievePaths {
		static readonly type = '[QuoteFlow] Allow All Paths'
	}

	export class Update {
		static readonly type = '[QuoteFlow] Update'
		constructor(public payload: boolean) {}
	}

	export class AddPath {
		static readonly type = '[QuoteFlow] Add Path'
		constructor(public payload: string) {}
	}

	export class RemovePath {
		static readonly type = '[QuoteFlow] Remove Path'
		constructor(public payload: string) {}
	}

	export class DisableCheckForExistingQuotes {
		static readonly type = '[QuoteFlow] Disable Check For Existing Quotes'
	}
}
